import "./Contact.css";
import { useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: "" });

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("phone", formData.phone);
      formDataToSend.append("message", formData.message);

      const response = await fetch("/api/contact.php", {
        method: "POST",
        body: formDataToSend,
      });

      const data = await response.json();

      if (data.success) {
        setStatus({ loading: false, success: true, error: "" });
        setFormData({ name: "", email: "", phone: "", message: "" });
        setTimeout(() => {
          setStatus({ loading: false, success: false, error: "" });
        }, 5000);
      } else {
        setStatus({
          loading: false,
          success: false,
          error: data.error || "Failed to send email",
        });
      }
    } catch (error) {
      setStatus({
        loading: false,
        success: false,
        error: "Network error. Please try again.",
      });
    }
  };

  return (
    <section className="contact-section">
      <div className="contact-container">
        <div className="contact-header">
          <h2 className="contact-title">Get in Touch</h2>
          <p className="contact-subtitle">
            We'd love to hear from you. Fill out the form or reach us directly.
          </p>
        </div>

        <div className="contact-grid">
          {/* Left Column - Contact Info */}
          <div className="contact-left">
            <div className="contact-info-box">
              <h3 className="contact-info-title">Contact Information</h3>
              <p className="contact-info-text">
                If you have any questions or inquiries, please don't hesitate to get
                in touch with us.
              </p>

              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-icon">📧</div>
                  <div className="contact-item-content">
                    <h4>Email</h4>
                    <p>lumaxsunlightenergy@gmail.com</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">📞</div>
                  <div className="contact-item-content">
                    <h4>Phone</h4>
                    <p>+91 9624053678</p>
                    <p>+91 9601653678</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">📍</div>
                  <div className="contact-item-content">
                    <h4>Address</h4>
                    <p>235, 2nd floor,</p>
                    <p>Gokuldham Arcade,</p>
                    <p>Near New RTO Office,</p>
                    <p>Ambaji Highway, Palanpur</p>
                    <p>385001</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Form */}
          <div className="contact-right">
            <div className="contact-form-box">
              <h3 className="form-title">Send us a Message</h3>

              {/* Success Message */}
              {status.success && (
                <div className="alert alert-success">
                  ✓ Email sent successfully! We'll get back to you soon.
                </div>
              )}

              {/* Error Message */}
              {status.error && (
                <div className="alert alert-error">
                  ✗ {status.error}
                </div>
              )}

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="+91 9876543210"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    placeholder="Tell us about your project or inquiry..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="contact-button"
                  disabled={status.loading}
                >
                  {status.loading ? "Sending..." : "Send Message"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;